const ErrorPage = () => {
  return <h1>console.error();</h1>;
};

export default ErrorPage;
